import React, { Component } from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import {
  withRouter
} from 'react-router-dom'

export default class EnterpriseBreadcrumb extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  navigateTo = (link) => {
    this.props.history.push(link);
  }

  render() {
    let {linkText, link, activeText,top} = this.props;
    return (
    <Breadcrumb className={top}>
      <BreadcrumbItem>
        <a className="create-chart-link cursor-pointer" onClick={() => this.navigateTo(link)}>{linkText}</a>
      </BreadcrumbItem>
      <BreadcrumbItem active><span className="breadcrumb-active-item">{activeText}</span></BreadcrumbItem>
    </Breadcrumb>);
  }
}
